import { Container } from '@pixi/react';
import { useEffect, useRef } from 'react';
import { Spine } from '../../../../../components';

export const JackpotLogo: React.FC = () => {
  const ref = useRef<any>();

  useEffect(() => {
    if (ref.current) {
      const spine: Spine = new Spine({ key: 'jackpotBackGroundLogo' });
      ref.current.addChild(spine);
      spine.play('idle', true);
    }
  }, []);
  return <Container ref={ref} {...({ name: 'JackpotBackGroundLogo' } as any)} />;
};
